import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon.jsx';

const { FiAward, FiCheck } = FiIcons;

const About = () => {
  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row items-center gap-16">
          <motion.div 
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="w-full lg:w-1/2 relative"
          >
            <div className="rounded-[3rem] overflow-hidden border-[12px] border-[#2c3a50] shadow-2xl skew-y-1">
              <img 
                src="https://static-media.hotmart.com/tAcLiR3ukCd0CAPhcXhTSoPRQ8s=/filters:quality(100)/klickart-prod/uploads/media/file/7456904/imagem_do_whatsapp_de_2024-02-22_(s)_19.23.28_34aaeca9.jpg" 
                alt="Simone Miranda Felipe" 
                className="w-full aspect-[4/5] object-cover"
              />
            </div>
            <div className="absolute -bottom-6 -right-6 bg-[#c5a059] p-8 rounded-3xl text-white shadow-2xl">
              <SafeIcon icon={FiAward} className="w-10 h-10 mb-2" />
              <p className="font-black text-lg text-white">EXPERIÊNCIA CLÍNICA</p>
              <p className="text-sm opacity-90 text-white">+12 ANOS DE PRÁTICA</p>
            </div>
          </motion.div>

          <div className="w-full lg:w-1/2">
            <span className="text-[#c5a059] font-black tracking-widest uppercase text-sm mb-2 block">A Especialista</span>
            <h2 className="text-5xl font-black text-[#2c3a50] mb-8 leading-none">SIMONE MIRANDA FELIPE</h2>
            
            <div className="space-y-6 text-lg text-gray-700 leading-relaxed text-justify">
              <p className="font-medium">
                Sou psicóloga clínica com mais de <b>12 anos de experiência</b> no atendimento infanto-juvenil. Minha missão é transformar conhecimentos científicos complexos em estratégias práticas e acessíveis para pais e responsáveis.
              </p>
              <p className="font-medium">
                Desenvolvi o <b>“Sementinha”</b>, um programa estruturado em técnicas lúdicas fundamentadas em evidências da Terapia Cognitivo-Comportamental (TCC), Terapia do Esquema, Teoria do Apego e Análise do Comportamento.
              </p>
              <p className="font-medium">
                Cada módulo é cuidadosamente pensado para habilitar os pais a promoverem habilidades socioemocionais, autorregulação e desenvolvimento cognitivo nas crianças de forma prática, segura e divertida.
              </p>
              <p className="font-medium">
                Aqui, não existe “achismo”: todo o programa é baseado em ciência aplicada, assim como nos meus atendimentos clínicos, oferecendo estratégias concretas e eficazes para o dia a dia familiar.
              </p>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-10">
                {['TCC', 'Teoria do Apego', 'Terapia do Esquema', 'Análise do Comportamento'].map((t, i) => (
                  <div key={i} className="flex items-center gap-4 bg-[#2c3a50]/5 p-4 rounded-2xl border border-[#2c3a50]/10">
                    <div className="w-8 h-8 bg-[#c5a059] rounded-full flex items-center justify-center shrink-0">
                      <SafeIcon icon={FiCheck} className="text-white w-5 h-5" />
                    </div>
                    <span className="font-bold text-[#2c3a50] text-sm">{t}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;